/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainPushNotificationsTokensPushNotificationPlatform } from './FxIdDomainPushNotificationsTokensPushNotificationPlatform';
import {
    FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON,
    FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSONTyped,
    FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON,
    FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSONTyped,
} from './FxIdDomainPushNotificationsTokensPushNotificationPlatform';

/**
 * 
 * @export
 * @interface FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs
 */
export interface FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs
     */
    Game: string;
    /**
     * 
     * @type {FxIdDomainPushNotificationsTokensPushNotificationPlatform}
     * @memberof FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs
     */
    Platform: FxIdDomainPushNotificationsTokensPushNotificationPlatform;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs
     */
    Token: string;
    /**
     * 
     * @type {Date}
     * @memberof FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs
     */
    ExpirationTime?: Date | null;
}



/**
 * Check if a given object implements the FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs interface.
 */
export function instanceOfFxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs(value: object): value is FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('Platform' in value) || value['Platform'] === undefined) return false;
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSON(json: any): FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs {
    return FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSONTyped(json, false);
}

export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'Platform': FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON(json['Platform']),
        'Token': json['Token'],
        'ExpirationTime': json['ExpirationTime'] == null ? undefined : (new Date(json['ExpirationTime'])),
    };
}

export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON(json: any): FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs {
    return FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSONTyped(json, false);
}

export function FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSONTyped(value?: FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'Platform': FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON(value['Platform']),
        'Token': value['Token'],
        'ExpirationTime': value['ExpirationTime'] == null ? undefined : ((value['ExpirationTime'] as any).toISOString()),
    };
}

